module.exports = __webpack_public_path__ + "img/floorMap.c37f57ca.png";